import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import * as React from 'react';
import { type ILabeledRadioButtonProps, LabeledRadioButton } from '../labeled-radio-button/labeled-radio-button';
import { cn } from '@utils';

const RadioGroup = React.forwardRef<
	React.ElementRef<typeof RadioGroupPrimitive.Root>,
	Omit<React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>, 'children'> & {
		options: ILabeledRadioButtonProps[];
	}
>(({ className, options, ...props }, ref) => {
	return (
		<RadioGroupPrimitive.Root className={cn('grid min-w-0 gap-2', className)} {...props} ref={ref}>
			{options.map(option => (
				<LabeledRadioButton key={option.value} {...option} />
			))}
		</RadioGroupPrimitive.Root>
	);
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

export { RadioGroup };
